
/**
* 用工中心 用工结算明细
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/task/employmentStatement' }"
        >用工结算单</el-breadcrumb-item
      >
      <el-breadcrumb-item>结算单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="background-color: #fff; padding: 15px; margin: 20px auto">
      <p
        style="
          line-height: 56px;
          border-bottom: 1px solid #e5e5e5;
          font-size: 16px;
          margin-top: 0;
        "
      >
        提交结算单
      </p>
      <el-row :gutter="20">
        <el-col :span="8"
          ><div>
            <div class="m-bott-15" style="margin-bottom: 15px">
              <span>商户名称：</span><span>{{ infos.merchantName }}</span>
            </div>
            <div class="m-bott-15">
              <span>结算成功笔数：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{ infos.settlementSuccessTotalNum }}</span
              >
            </div>
            <div class="m-bott-15">
              <span>结算成功服务费：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{ infos.settlementSuccessServiceFee }}</span
              >
            </div>
            <div class="m-bott-15">
              <span>结算单批次ID：</span><span>{{ infos.batchNumber }}</span>
            </div>
          </div></el-col
        >
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>结算单名称：</span><span>{{ infos.batchName }}</span>
            </div>
            <div class="m-bott-15">
              <span>验证成功笔数：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{ infos.verificationSuccessTotalNum }}</span
              >
            </div>
            <div class="m-bott-15">
              <span>验证成功服务费：</span
              ><span
                :style="{
                  color: getStatusColor(7),
                }"
                >{{ infos.verificationSuccessServiceFee }}</span
              >
            </div>
          </div></el-col
        >
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>创建时间：</span><span>{{ infos.createdAt }}</span>
            </div>
            <div class="m-bott-15">
              <span>结算失败笔数：</span
              ><span
                :style="{
                  color: getStatusColor(8),
                }"
                >{{ infos.settlementFailTotalNum }}</span
              >
            </div>
            <div class="m-bott-15">
              <span>结算失败服务费：</span
              ><span
                :style="{
                  color: getStatusColor(8),
                }"
                >{{ infos.settlementFailServiceFee }}</span
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="detailId" fixed label="结算单ID" min-width="120">
      </el-table-column>
      <el-table-column label="收款信息" min-width="170">
        <template slot-scope="scope">
          <span>
            {{ scope.row.payeeName }}<br />
            {{ scope.row.payeeAccount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="证件信息" min-width="210">
        <template slot-scope="scope">
          <span>
            {{ scope.row.identityDocumentTypeStr }}<br />
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="结算单状态" min-width="120">
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.status),
            }"
            >{{ scope.row.statusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="状态描述" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.detailsRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="服务费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="preAmount"
        label="税前金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="到账金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFee"
        label="管理费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeMode"
        label="管理费承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>

          <span v-else-if="scope.row.managementFeeMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >
          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxRate"
        label="个税税率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="收款备注" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="transSequenceIdn"
        label="流水号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="serviceCharge"
        label="计费范围"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.minCharge }}元~{{ scope.row.maxCharge }}元</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="workload"
        label="工作量"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="rewardsPunishments"
        label="奖惩"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="info"
        label="编号信息"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSettlementDetailsByBatchNumber,
  checkAggregationResult,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      merchantName_list: [
        {
          label: JSON.parse(localStorage.getItem("user_info")).name,
          value: JSON.parse(localStorage.getItem("user_info")).name,
        },
      ],
      status_list: [
        {
          label: "校验中",
          value: 1,
        },
        {
          label: "初验成功",
          value: 2,
        },
        {
          label: "验证失败",
          value: 3,
        },
        {
          label: "已取消",
          value: 4,
        },
        {
          label: "待结算",
          value: 5,
        },
        {
          label: "结算中",
          value: 6,
        },
        {
          label: "结算成功",
          value: 7,
        },
        {
          label: "结算失败",
          value: 8,
        },
        {
          label: "已退款",
          value: 9,
        },
        {
          label: "已退票",
          value: 10,
        },
        {
          label: "银行挂账",
          value: 11,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        pay_date: [],
        date: [],
        positionId: "",
        taskName: "",
        positionState: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
      },
      infos: {},
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    checkAggregationResult(this.$route.query.id)
      .then((res) => {
        this.loading = false;
        if (res.msg != "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
        } else {
          this.infos = res.data;
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStatusColor(status) {
      // {
      //     label: "校验中",
      //     value: 1,
      //   },
      //   {
      //     label: "初验成功",
      //     value: 2,
      //   },
      //   {
      //     label: "验证失败",
      //     value: 3,
      //   },
      //   {
      //     label: "已取消",
      //     value: 4,
      //   },
      //   {
      //     label: "待结算",
      //     value: 5,
      //   },
      //   {
      //     label: "结算中",
      //     value: 6,
      //   },
      //   {
      //     label: "结算成功",
      //     value: 7,
      //   },
      //   {
      //     label: "结算失败",
      //     value: 8,
      //   },
      //   {
      //     label: "已退款",
      //     value: 9,
      //   },
      //   {
      //     label: "已退票",
      //     value: 10,
      //   },
      //   {
      //     label: "银行挂账",
      //     value: 11,
      //   },
      // 根据状态值返回对应的颜色
      switch (status) {
        case 1:
        case 5:
        case 6:
          return "#409EFF"; // 蓝色
        case 2:
        case 7:
          return "#67C23A"; // 绿色
        case 4:
          return "#909399"; // 灰色
        case 3:
        case 8:
        case 9:
        case 10:
        case 11:
          return "#F56C6C"; // 红色

        default:
          return "#303133"; // 默认黑色
      }
    },
    exportdata() {
      if (!this.$route.query.id) {
        this.$message.error("参数错误，批次号为空");
        return;
      }

      // 默认导出1000
      const params = {
        page: 1,
        pageSize: 1000,
        isExport: 1,
      };

      getSettlementDetailsByBatchNumber(this.$route.query.id, params).then(
        (res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        }
      );
    },
    // 获取公司列表
    getdata(parameter) {
      if (!this.$route.query.id) {
        this.$message.error("参数错误，批次号为空");
        return;
      }

      this.loading = true;
      getSettlementDetailsByBatchNumber(this.$route.query.id, parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {},
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          //  deptSave(this.editForm)
          //    .then(res => {
          //      this.editFormVisible = false
          //      this.loading = false
          //      if (res.success) {
          //        this.getdata(this.formInline)
          //        this.$message({
          //          type: 'success',
          //          message: '公司保存成功！'
          //        })
          //      } else {
          //        this.$message({
          //          type: 'info',
          //          message: res.msg
          //        })
          //      }
          //    })
          //    .catch(err => {
          //      this.editFormVisible = false
          //      this.loading = false
          //      this.$message.error('公司保存失败，请稍后再试！')
          //    })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //  deptDelete(row.deptId)
          //    .then(res => {
          //      if (res.success) {
          //        this.$message({
          //          type: 'success',
          //          message: '公司已删除!'
          //        })
          //        this.getdata(this.formInline)
          //      } else {
          //        this.$message({
          //          type: 'info',
          //          message: res.msg
          //        })
          //      }
          //    })
          //    .catch(err => {
          //      this.loading = false
          //      this.$message.error('公司删除失败，请稍后再试！')
          //    })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.m-bott-15 {
  margin-bottom: 15px;
}
</style>





// WEBPACK FOOTER //
// src/views/task/employmentStatementDetail.vue